import { Box } from "@mui/material";

/**
 * The brand emblem's three ascending bars (geometry verbatim from the Insight
 * Analytics Brand Identity mark, as inlined on the landing site) looping a
 * staggered rise while the plan loader runs. Solid green at the emblem's
 * canonical 0.6/0.8/1.0 opacity stepping — the landing's gradient fill is a
 * landing-only deviation; flat rules hold here.
 */

interface EmblemLoaderProps {
  size?: number;
}

export const EmblemLoader = ({ size = 64 }: EmblemLoaderProps) => (
  <Box
    aria-hidden
    sx={{
      width: size,
      height: size * (570 / 672),
      lineHeight: 0,
      "@keyframes emblemRise": {
        "0%": { transform: "scaleY(0.2)", opacity: 0.3 },
        "45%, 70%": { transform: "scaleY(1)", opacity: 1 },
        "100%": { transform: "scaleY(0.2)", opacity: 0.3 },
      },
      "& .emblem-bar": {
        transformBox: "fill-box",
        transformOrigin: "bottom",
        animation: "emblemRise 1.8s ease-in-out infinite",
      },
      "@media (prefers-reduced-motion: reduce)": {
        "& .emblem-bar": { animation: "none" },
      },
    }}
  >
    <svg viewBox="0 0 672 570" width="100%" fill="none">
      <polygon
        className="emblem-bar"
        fill="#22c55e"
        opacity={0.6}
        style={{ animationDelay: "0s" }}
        points="187.75 340.1 0 340.1 82.7 506.95 265.68 506.95 261.15 488.18 187.75 340.1"
      />
      <polygon
        className="emblem-bar"
        fill="#22c55e"
        opacity={0.8}
        style={{ animationDelay: "0.15s" }}
        points="357.05 168.68 183.97 168.68 265.68 506.95 265.79 506.95 265.81 507.07 438.75 507.18 438.75 506.48 357.05 168.68"
      />
      <polygon
        className="emblem-bar"
        fill="#22c55e"
        style={{ animationDelay: "0.3s" }}
        points="438.75 0 438.75 506.48 438.75 507.18 438.92 507.18 606.97 507.29 606.97 0 438.75 0"
      />
    </svg>
  </Box>
);
